import { MapConfig } from '@foxeet/domain';

export const mapConfig: MapConfig = {
  colors: {
    neighborMarkers: '#d8664f',
  },
};
